<template>
  <SOSlotBase
      container-name="container-input-scan"
      :loading="loading"
  >
    <template v-slot:content>
      <SOTitleBar
          page-title="Scan QR Code Mesin"
          type="close"
          :transparent="false"
          @back="back"
      />
      <SOInputScan
          text-header="Scan QR Code Mesin"
          :optional-input="true"
          @decode="toTambah"
      />
    </template>
    <template v-slot:loading-page>
      <SOLoadingPage v-if="loading"/>
    </template>
  </SOSlotBase>
</template>

<script>
import SOInputScan from "@/so-components/global/input/SOInputScan";
import SOModalInputManual from "@/so-components/global/modal/SOModalInputManual";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import {mapGetters} from "vuex";

export default {
  name: "SnapMesinScanId",
  components: {SOLoadingPage, SOTitleBar, SOSlotBase, SOModalInputManual, SOInputScan},
  data() {
    return {
      loading: true
    }
  },
  methods: {
    async toTambah(result) {
      const res = await this.$store.dispatch("snapMesinModule/cekIdMesin", result)
      if (!res.success) {
        this.$toast.error(res.err)
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      } else {
        this.input.id = result
        this.$toast.success(res.msg)
        await this.$router.push({
          name: "SnapMesinTambah",
          params: {
            idoutlet: this.$route.params.idoutlet,
          },
        })
      }
    },

    back() {
      if (window.screen.width > 600) {
        $("#nav-bottom").show()
        $(".sidebar-menu").show()
        $(".view-screen").css("margin", "0px auto 0px 350px")
      }
      setTimeout(() => {
        this.$router.push({
          name: "ListSnapMesin",
          query: {
            idoutlet: this.$route.params.idoutlet
          }
        })
      }, 200)
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
  computed: {
    ...mapGetters("snapMesinModule", {
      input: "getDataCreateMesin"
    })
  }
}
</script>

<style scoped>

</style>